export class AngularProgressItem {
    titolo: string;
    descrizione: string;
    completato: boolean;
    linkUrl: string;
    numColStep: number;
    ultimoDellaRiga: boolean;
    primoDellaRiga: boolean;
    idUrl: number;
}



// WEBPACK FOOTER //
// ./src/angular_library/models/angular-progress-item.ts